import document from './assets/document.png';
import devices from './assets/devices.png';
import gear from './assets/gear.png';
import lock from './assets/lock.png';
import child from './assets/child.png';
import california from './assets/california.png';
import nevada from './assets/nevada.png';
import lightbulb from './assets/lightbulb.png';
import shareInfo from './assets/shareInfo.png';

export default {
  personal: {
    title: 'What Personal Information Do We Collect?',
    image: document,
    alt: 'Document Icon',
  },
  collect: {
    title: 'Where/How Do We Collect Information About You?',
    image: devices,
    alt: 'Devices Icon',
  },
  use: {
    title: 'How Do We Use Your Information?',
    image: gear,
    alt: 'Gear Icon',
  },
  share: {
    title: 'Who Do We Share Your Information With?',
    image: shareInfo,
    alt: 'Share Icon',
  },
  control: {
    title: 'How Can You Control Our Use of Your Information?',
    image: lock,
    alt: 'Lock Icon',
  },
  children: {
    title: 'Children’s Privacy',
    image: child,
    alt: 'Child Icon',
  },
  section4: {
    title: 'Rights for Our California Residents',
    image: california,
    alt: 'California Icon',
  },
  nevada: {
    title: 'Rights for Our Nevada Residents',
    image: nevada,
    alt: 'Nevada Icon',
  },
  learn: {
    title: 'How You Can Learn More',
    image: lightbulb,
    alt: 'Lightbulb Icon',
  },
};
